import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

const IconUserSettings = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <g>
        <circle fill={fill} cx='10.009' cy='6.5' r='4' />
        <path
          fill={fill}
          opacity={0.3}
          d='M15.38,13.48A5.631,5.631,0,0,0,12,12.5H8c-4.06,0-5.5,2.97-5.5,5.52C2.5,20.3,3.71,21.5,6,21.5h7.03a.278.278,0,0,0,.29-.29.716.716,0,0,0-.08-.22l-.52-.89a1.62,1.62,0,0,1-.15-1.29,1.559,1.559,0,0,1,.34-.6A.333.333,0,0,0,13,18a.312.312,0,0,0-.09-.21,1.621,1.621,0,0,1-.23-1.82.929.929,0,0,1,.05-.1l.76-1.25a1.64,1.64,0,0,1,1.43-.84,1.267,1.267,0,0,1,.34.04c.02,0,.04.01.07.01a.156.156,0,0,0,.17-.18C15.5,13.57,15.42,13.51,15.38,13.48Z'
        />
        <path
          fill={fill}
          d='M21.18,18a1.326,1.326,0,0,1,.69-1.16l.13-.07-.92-1.54-.13.07a1.412,1.412,0,0,1-1.38,0,1.333,1.333,0,0,1-.68-1.15.156.156,0,0,0-.16-.15H17.21a.147.147,0,0,0-.15.15,1.322,1.322,0,0,1-.69,1.15,1.413,1.413,0,0,1-1.38,0,.149.149,0,0,0-.2.06l-.77,1.28a.185.185,0,0,0-.02.07.156.156,0,0,0,.08.13A1.337,1.337,0,0,1,14.76,18v.03a1.334,1.334,0,0,1-.68,1.13.141.141,0,0,0-.06.2l.76,1.28a.172.172,0,0,0,.14.08.145.145,0,0,0,.07-.02,1.412,1.412,0,0,1,1.38,0,1.319,1.319,0,0,1,.68,1.12v.03a.156.156,0,0,0,.16.15h1.53a.154.154,0,0,0,.15-.15,1.333,1.333,0,0,1,.68-1.15,1.412,1.412,0,0,1,1.38,0,.161.161,0,0,0,.21-.06l.76-1.28a.108.108,0,0,0,.02-.08.131.131,0,0,0-.07-.12A1.326,1.326,0,0,1,21.18,18Zm-3.16,1.14a1.14,1.14,0,1,1-.01-2.28h.01a1.14,1.14,0,1,1,0,2.28Z'
        />
      </g>
    </svg>
  )
}

export default IconUserSettings
